/**
 * 展示管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const showcaseService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.SHOWCASE.LIST, { 
      params
    });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.SHOWCASE.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.SHOWCASE.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.SHOWCASE.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.SHOWCASE.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(API_ENDPOINTS.SHOWCASE.BATCH_DELETE, { data: ids });
  }
};